(function() {

    'use strict';

    var feat = SAPO.Project.Video.Features;
    var pageProtocol = feat.pageProtocol();

    /**
     * @module Plugins
     *
     * This plugin provides a way of sending KPI events to remote endpoints.
     *
     * Uses images to fire and forget.
     *
     * @namespace metro
     */

    /**
     * @module Messages
     *
     * Sends KPI(s) to uriOrUris.
     *
     * @function metro
     * @param {String}       messageKind='metro'
     * @param {String|Array} uriOrUris
     * @param {String}       [debugInfo]
     */

    var rnd = function() {
        return ~~(Math.random() * 1000000);
    };

    var sendAsImg = function(uri) {

        // TODO DEBUG
        /*try {
            if (window.top.logMetro) { window.top.logMetro.push(uri); }
        } catch (ex) {}*/

        new Image().src = [uri.replace(/^(http:|https:)/, pageProtocol), '&rnd=', rnd()].join('');
    };



    var plugin = function(vc, ui) {
        this._vc = vc;
        this._ui = ui;

        this._vc.subscribe('metro', undefined, this);
    };

    plugin.prototype = {

        _name: plugin._name = 'metro',

        // BASIC TEST
        /*on_metro: function(mt, uri, dbg) {
            if (!uri) { return; }
            if (dbg) { return console.log('METRO:', dbg, ' -> ', uri); }
            // if (dbg) { return console.log('METRO:', dbg); }
            // if (dbg) { return window.top.log('METRO:', dbg, ' -> ', uri); }
        }*/


        // FUNCTIONAL TEST
        /*on_metro: function() {
            window.parent.SAPO.Project.Video.kpi( Array.prototype.slice.call(arguments) );
        }*/


        // FORCE FAIL
        /*on_metro: function(mt, uri, dbg) {
            if (dbg === 'start') {
                debugger;
            }
        }*/

        // REMOTE TEST
        /*on_metro: function(mt, uri, dbg) {
            var res = [];

            if (uri instanceof Array) {
                for (var i = 0, f = uri.length; i < f; ++i) {
                    res.push(uri[i]);
                }
            }
            else {
                res.push(uri);
            }

            sendAsImg('http://js.brushed-sapo.pt:3333?' + dbg + ': ' + res.join(' '));
        }*/

        // PROD
        on_metro: function(mt, uri) {
            if (!uri) { return; }

            if (uri instanceof Array) {
                for (var i = 0, f = uri.length; i < f; ++i) {
                    sendAsImg(uri[i]);
                }
                return;
            }

            sendAsImg(uri);
        }
    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
